/*
 * Copyright (c) Nexign, JSC, 2022.
 */
/**
 *
 *
 * @author Yakov Gushchin
 * @version 1.17.0
 * @since 1.17.0
 */

import { createElement, FC, Fragment } from 'react';

import ReactDOM from 'react-dom';

import { CORPORATE_PAGE_PORTAL_ID } from './constants';
import { CorporatePagePortalStyled } from './styled/CorporatePagePortalStyled';

const CorporatePagePortal: FC = ({ children }) => {
    const pageContainerNode = document && document.getElementById(CORPORATE_PAGE_PORTAL_ID);

    return (
        <Fragment>
            {
                pageContainerNode && ReactDOM.createPortal(
                    createElement(CorporatePagePortalStyled, { children }),
                    pageContainerNode,
                )
            }
        </Fragment>
    );
};

export default CorporatePagePortal;
